// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { OrganizationDetailsData } from './organization-details.interfaces';
import { selectOrganizationDetail } from './organization-details.selectors';
import { filter, map, tap } from 'rxjs/operators';
import { LoadingOrganizationDetailsAction } from './organization-details.actions';
import { select, Store } from '@ngrx/store';
import { Loadable, ScopeCategory } from '@app/core';
import { State } from '@app/access-management/state';

@Injectable({ providedIn: 'root' })
export class OrganizationDetailsFacadeService {
  loadableDetails$: Observable<Loadable | undefined> = of();
  organization$: Observable<ScopeCategory> = of();

  constructor(private store: Store<State>) {}

  initialize(orgId: string) {
    this.store.dispatch(new LoadingOrganizationDetailsAction(orgId));

    const organizationDetails$: Observable<OrganizationDetailsData> = this.store.pipe(
      select(selectOrganizationDetail(orgId)),
      filter<OrganizationDetailsData>(data => !!data)
    );

    this.organization$ = organizationDetails$.pipe(map(data => data.organization));
  }
}



// WEBPACK FOOTER //
// ./src/app/access-management/state/organization-details/organization-details.facade.ts